import { render } from "./MobileHollySys.vue?vue&type=template&id=1b1e5fb4&scoped=true"
import script from "./MobileHollySys.vue?vue&type=script&lang=js"
export * from "./MobileHollySys.vue?vue&type=script&lang=js"

import "./MobileHollySys.vue?vue&type=style&index=0&id=1b1e5fb4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1e5fb4"]])

export default __exports__